import { ModelBase } from 'store/model-base';

export class CmsSmb extends ModelBase {
    public static storeName: string = 'cmsSmb';

    public eligibleCustomer: CmsEligibleCustomer;
    public ineligibleCustomer: CmsBusinessIneligibleCustomer;
    public confirmation: CmsBusinessSubmitConfirmation;
}
